






























import { CampaignReportData } from "@/models/CampaignReport";
import CampaignsAPI from "@/services/campaigns";
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import CampaignReport from "@/views/Campaigns/CampaignReport.vue";
import ClientCampaignReport from "@/views/Campaigns/Components/ClientCampaignReport.vue";

@Component({
  components: { ClientCampaignReport },
})
export default class PublicReport extends Vue {
  appLogo = require("@/assets/app-logo.png");
  campaignId = "";
  token = "";
  data?: CampaignReportData;
  loading = false;

  async created(): Promise<void> {
    this.loading = true;
    this.token = this.$route.query.token
      ? (this.$route.query.token as string)
      : "";
    this.campaignId = this.$route.params.id
      ? (this.$route.params.id as string)
      : "";
    try {
      const r = await CampaignsAPI.getPublicReport(this.campaignId, this.token);

      this.data = r;
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  }
}
